import React from 'react'
import { ArrowRight } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'
import { useLanguage } from '../../contexts/LanguageContext'

const WeAreZM = () => {
    const { t } = useLanguage();
    return (
        <div id='website-responsive'>
            <div className='left-padding8rem1 right-padding8rem1 py-md-5 py-4'>
                <Row className=''>
                    <Col sm='12' md='12' lg='6' className=''>
                        <div className='memd-5'>
                            <div className='memd-5'>
                                <h3 className='text-philos fs-ss-38 text-ss-black fw-800'>
                                    {t('about.weAreZM.title')}
                                </h3>
                            </div>
                            <div className='pt-md-3 pt-2 me-md-4'>
                                <p className='fs-ss-18 text-mulish fw-500 lh-1-8 '>
                                {t('about.weAreZM.description')}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col sm='12' md='12' lg='6' className=''>
                        <div className=''>
                            <img src='about/About-us-.webp' alt='software development & digital marketing agency in Germany' className='img-home-1' height='' width='' />
                        </div>
                    </Col>
                </Row>

                <div className='mt-md-5 mt-4'>
                <h3 className='text-philos fs-ss-38 text-ss-black fw-800'>
                    <center>
                        {t('about.coreValues')}
                    </center>
                </h3>
                </div>
                
                <div className='pt-md-3 pt-' style={{ textAlign:'justify'}}>
                <p className='fs-ss-18 text-mulish fw-500 lh-1-8' style={{ textAlign:'justify'}}>
                    <center>
                        {t('about.coreValuesDescription')}
                    </center>
                </p>
                </div>
            </div>
        </div>
    )
}

export default WeAreZM